import { render, staticRenderFns } from "./whyChoose.vue?vue&type=template&id=84f7540e"
import script from "./whyChoose.vue?vue&type=script&lang=js"
export * from "./whyChoose.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports